import { TConvertor, TFetchConverter,} from 'data/types/Converter.types';
import {
  EApplicationStepName,
  EApplicationStepNameUi,
  EApplicationStepType,
  EApplicationStepTypeUi,
  EApplicationTypeDB,
  EApplicationTypeUI,
  EMethodDB,
  EMethodUI,
  EStatusChangerRoleDB,
  EStatusChangerRoleUI,
} from 'data/types/Applications.types';

export const applicationStatusChangerRoleConvertor: TConvertor<
  EStatusChangerRoleUI,
  EStatusChangerRoleDB
> = {
  fromDb: data => {
    return EStatusChangerRoleUI[
      EStatusChangerRoleDB[data] as keyof typeof EStatusChangerRoleUI
    ];
  },
  toDb: data => {
    switch (data) {
      case EStatusChangerRoleUI.ADMIN:
        return EStatusChangerRoleDB.ADMIN;
      default:
        return EStatusChangerRoleDB.PROPERTY_MANAGER;
    }
  },
};

export const applicationTypeConvertor: TConvertor<
  EApplicationTypeUI,
  EApplicationTypeDB
> = {
  fromDb: data => {
    return EApplicationTypeUI[
      EApplicationTypeDB[data] as keyof typeof EApplicationTypeUI
    ];
  },
  toDb: data => {
    return EApplicationTypeDB[
      EApplicationTypeUI[data] as keyof typeof EApplicationTypeDB
    ];
  },
};

export const applicationStepNameConvertor: TConvertor<
  EApplicationStepNameUi,
  EApplicationStepName
> = {
  fromDb: data => {
    return EApplicationStepNameUi[
      EApplicationStepName[data] as keyof typeof EApplicationStepNameUi
    ];
  },
  toDb: data => {
    return EApplicationStepName[
      EApplicationStepNameUi[data] as keyof typeof EApplicationStepName
    ];
  },
};

export const applicationStepTypeConvertor: TConvertor<
  EApplicationStepTypeUi,
  EApplicationStepType
> = {
  fromDb: data => {
    return EApplicationStepTypeUi[
      EApplicationStepType[data] as keyof typeof EApplicationStepTypeUi
    ];
  },
  toDb: data => {
    return EApplicationStepType[
      EApplicationStepTypeUi[data] as keyof typeof EApplicationStepType
    ];
  },
};

export const methodsConvertor: TFetchConverter<EMethodUI, EMethodDB> = {
  fromDb: (data) => {
    return EMethodUI[EMethodDB[data] as keyof typeof EMethodUI];
  },
};